// Funções puras do layout do Meu Painel (PO1-3439 / PO1-3440).
// Um layout é uma lista ordenada de { widgetId, tamanho }.
import { temPermissao } from "../AuditoriaPedido/regras";

export const MAX_WIDGETS = 60;

// Widget disponível para este usuário neste produto (PO1-3494): sem `produtos`
// vale para todos; sem `permissao` não exige nada. O layout salvo NÃO é
// alterado por isso — o widget indisponível só fica escondido (volta quando o
// usuário trocar de produto).
export function widgetDisponivel(def, { produto, user } = {}) {
  if (!def) return false;
  if (Array.isArray(def.produtos) && def.produtos.indexOf(produto) === -1) return false;
  if (def.permissao && !temPermissao(user, def.permissao)) return false;
  return true;
}

export const SUGESTAO_INICIAL = [
  { widgetId: "indicadores-frete", tamanho: "G" },
  { widgetId: "chart-frete-por-transp", tamanho: "M" },
  { widgetId: "chart-frete-por-uf", tamanho: "M" },
  { widgetId: "indicadores-entrega", tamanho: "G" },
  { widgetId: "chart-prazo-por-transp", tamanho: "G" },
  { widgetId: "kanban-status-fatura", tamanho: "G" },
];

// Tira o que o catálogo não conhece (widget descontinuado não quebra o painel),
// remove repetidos e troca tamanho não permitido pelo tamanho padrão do widget.
export function sanitizarLayout(layout, catalogoPorId) {
  if (!Array.isArray(layout)) return [];
  const vistos = {};
  const resultado = [];
  layout.forEach((item) => {
    const widgetId = item && item.widgetId;
    const def = widgetId ? catalogoPorId[widgetId] : null;
    if (!def || vistos[widgetId]) return;
    vistos[widgetId] = true;
    const tamanho =
      item.tamanho && def.tamanhos.indexOf(item.tamanho) !== -1
        ? item.tamanho
        : def.tamanhoPadrao;
    resultado.push({ widgetId, tamanho });
  });
  return resultado.slice(0, MAX_WIDGETS);
}

export function moverItem(layout, de, para) {
  if (de === para || de < 0 || para < 0 || de >= layout.length || para >= layout.length) {
    return layout;
  }
  const copia = layout.slice();
  const [item] = copia.splice(de, 1);
  copia.splice(para, 0, item);
  return copia;
}

export function trocarTamanho(layout, widgetId, tamanho) {
  return layout.map((item) =>
    item.widgetId === widgetId ? { ...item, tamanho } : item
  );
}

export function adicionar(layout, widgetId, catalogoPorId) {
  const def = catalogoPorId[widgetId];
  if (!def || layout.some((item) => item.widgetId === widgetId)) return layout;
  if (layout.length >= MAX_WIDGETS) return layout;
  return [...layout, { widgetId, tamanho: def.tamanhoPadrao }];
}

export function remover(layout, widgetId) {
  return layout.filter((item) => item.widgetId !== widgetId);
}
